/**
* Date validation
*/

import moment from 'moment';

const inputYear: any = document.querySelector('[name="year"]');
const inputMonth: any = document.querySelector('[name="month"]');
const inputDay: any = document.querySelector('[name="day"]');
const error = document.querySelector(".date-error");

function checkDate() {
  let dateFormat = "YYYY-MM-DD";
  let defaultDate = moment(new Date()) as any;
  defaultDate = moment(defaultDate).add('2', 'days').format(dateFormat)
  
  let selectDate = (inputYear.value + '-' + inputMonth.value + '-' + inputDay.value).toString();
  let date = moment(selectDate).format(dateFormat);
  let result = moment(date, 'YYYY-MM-DD', true).isValid();

  if (!error) return;
  if (result == true) {
    if(!moment(date).isSameOrAfter(defaultDate) == true) {
      error.classList.add("show");
      error.innerHTML = "有効な日付を選択してください。";
    }
    else {
      error.classList.remove("show");
      error.innerHTML = "";
    }
  }
  else {
    error.classList.add("show");
    error.innerHTML = "日付が存在しない。";
  }
}

const orderDate = () => {
  if (!(inputYear || inputMonth || inputDay)) return;
  inputYear.addEventListener("change", () => {
    checkDate();
  })
  inputMonth.addEventListener("change", () => {
    checkDate();
  })
  inputDay.addEventListener("change", () => {
    checkDate();
  })
}

export default orderDate
